export default __webpack_public_path__ + "static/media/Delimiter.96ccdbfa.svg";